import React from 'react';
import { Button, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

export const HomePage: React.FC = () => {
  const navigate = useNavigate();
  return <>
  <Typography.Title level={3}>Welcome to Golden Hounds Admin</Typography.Title>
  <Typography.Paragraph type="secondary">
    Manage game settings, view metrics, and review members and transactions from the sidebar.
  </Typography.Paragraph>
  <Space wrap>
    <Button type="primary" onClick={() => navigate('/metrics')}>Game Metrics</Button>
    <Button onClick={() => navigate('/users')}>Users</Button>
    <Button onClick={() => navigate('/transactions')}>Wallet Transactions</Button>
    <Button onClick={() => navigate('/geo-access/rules')}>Geo Block Rule</Button>
  </Space>
</>;
};
